import * as tslib_1 from "tslib";
import { OnChanges, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import * as moment from 'moment';
import { LoaderService } from 'src/app/loader.service';
import { AlertDialogService } from 'src/app/shared/alert-dialog/alert-dialog.service';
import { Toaster, ToasterType } from 'src/app/shared/types/toaster.types';
import { ToasterService } from 'src/app/toaster.service';
import Utils from 'src/app/utils/utils';
import { SubscriptionService } from '../../subscription.service';
import { subscriptionCreateSuccessAlert, subscriptionOperationFailureAlert } from '../../subscription.create-alert';
var CreateTrialSubsComponent = /** @class */ (function () {
    function CreateTrialSubsComponent(subsService, loader, alertService, toasterService, dialog) {
        this.subsService = subsService;
        this.loader = loader;
        this.alertService = alertService;
        this.toasterService = toasterService;
        this.dialog = dialog;
        this.context = null;
        this.formGroup = new FormGroup({
            ruleName: new FormControl(null),
            city: new FormControl(null),
            services: new FormControl([]),
            priority: new FormControl(null),
            startDate: new FormControl(null),
            endDate: new FormControl(null),
            ruleType: new FormControl({ value: 'zeroCommission', disabled: true }),
            maxRides: new FormControl(null),
            periodInDays: new FormControl(null),
            suspendServicesPostExpiry: new FormControl(true)
        });
        this.services = [];
        this.today = moment().startOf('hour').toDate();
        this.tomorrowEod = moment().endOf('day').minutes(30).add(1, 'days').toDate();
        this.minEndDate = this.tomorrowEod;
        this.Utils = Utils;
        this.overlappingRules = [];
        this.lastServiceKey = '';
    }
    CreateTrialSubsComponent.prototype.ngOnInit = function () {
        this.applyContext();
    };
    CreateTrialSubsComponent.prototype.ngOnChanges = function () {
        this.applyContext();
    };
    CreateTrialSubsComponent.prototype.formValue = function (name) {
        return this.formGroup.get(name).value;
    };
    CreateTrialSubsComponent.prototype.blockInvalidNumberKeys = function (event) {
        if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E') {
            event.preventDefault();
        }
    };
    CreateTrialSubsComponent.prototype.rejectNonPositiveAmount = function (event, controlName) {
        var input = event.target;
        if (input.value === '' || input.value == null) {
            return;
        }
        if (Number(input.value) <= 0) {
            this.formGroup.get(controlName).setValue(null);
            input.value = '';
        }
    };
    CreateTrialSubsComponent.prototype.changeInDate = function () {
        var startDate = this.formValue('startDate');
        if (startDate) {
            this.minEndDate = startDate;
        }
        var endDate = this.formValue('endDate');
        if (endDate) {
            this.maxStartDate = endDate;
        }
    };
    CreateTrialSubsComponent.prototype.errorMessage = function (message) {
        this.toasterService.showToaster(new Toaster({
            type: ToasterType.WARNING,
            message: message
        }));
    };
    CreateTrialSubsComponent.prototype.validateField = function (fieldName, message) {
        var value = this.formValue(fieldName);
        if (!value) {
            this.errorMessage(message);
            throw new Error(message);
        }
        return value;
    };
    CreateTrialSubsComponent.prototype.createTrialRule = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ruleName, city, selectedIds, byId_1, services, startTime, endTime, priority, maxRides, periodInDays, message, serviceDetailIds, priorityNum, existing, overlapError_1, payload, resp, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loader.openLoading();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, 8, 9]);
                        ruleName = this.validateField('ruleName', 'Rule name is required');
                        city = this.validateField('city', 'City is required');
                        selectedIds = this.formValue('services') || [];
                        if (!selectedIds.length) {
                            this.errorMessage('Services is required');
                            throw new Error('Services is required');
                        }
                        byId_1 = {};
                        this.services.forEach(function (service) {
                            byId_1[service.id] = service;
                        });
                        services = selectedIds.map(function (id) { return byId_1[id]; }).filter(Boolean);
                        if (!services.length) {
                            this.errorMessage('Services is required');
                            throw new Error('Services is required');
                        }
                        startTime = moment(this.validateField('startDate', 'Purchase Start date is required').getTime()).unix();
                        endTime = moment(this.validateField('endDate', 'Purchase End date is required').getTime()).unix();
                        priority = this.validateField('priority', 'Priority is required');
                        maxRides = this.validateField('maxRides', 'Max rides is required');
                        periodInDays = this.validateField('periodInDays', 'Period in days is required');
                        if (!Number.isInteger(Number(periodInDays)) || Number(periodInDays) <= 0) {
                            message = 'Period in days must be a positive whole number';
                            this.errorMessage(message);
                            throw new Error(message);
                        }
                        serviceDetailIds = services.map(function (s) { return s.serviceDetailId; });
                        priorityNum = Number(priority);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.subsService
                                .getSamePriorityRules(serviceDetailIds, startTime, endTime, [priorityNum])
                                .toPromise()];
                    case 3:
                        existing = _a.sent();
                        if (existing && existing.length > 0) {
                            this.overlappingRules = existing;
                            this.dialog.open(this.OverlappingPriorityRuleAlert);
                            return [2 /*return*/];
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        overlapError_1 = _a.sent();
                        console.warn('Could not verify overlapping rules', overlapError_1);
                        this.alertService.open({
                            title: 'Error',
                            message: 'Could not verify overlapping rules. Please try again.'
                        });
                        return [2 /*return*/];
                    case 5:
                        payload = {
                            type: 'TRIAL',
                            rules: [{
                                    ruleName: ruleName,
                                    startTime: startTime,
                                    endTime: endTime,
                                    priority: priorityNum,
                                    city: city.id,
                                    services: services.map(function (s) { return s.id; }),
                                    serviceDetails: serviceDetailIds,
                                    mode: this.context.mode.id,
                                    categoryLevelApplicability: {
                                        categories: [{
                                                id: this.context.category.id,
                                                allowedServices: [],
                                                excludedServices: []
                                            }]
                                    },
                                    isAutoAssignedToHH: false,
                                    isAutoAssignedToMC: false,
                                    isDefaultSubscription: false,
                                    exclusiveOfTax: false,
                                    userSelectors: [],
                                    userSelectorName: null,
                                    excludeIncentiveTypes: [],
                                    ruleType: 'zeroCommission',
                                    suspendServicesPostExpiry: true,
                                    rule: [{
                                            variable: 'commission',
                                            operator: '=',
                                            value: 0,
                                            type: 'flat'
                                        }],
                                    validity: [{ type: 'rides', maxValue: Number(maxRides) }],
                                    ruleAmount: 0,
                                    periodInDays: Number(periodInDays),
                                    isRecommended: false
                                }]
                        };
                        return [4 /*yield*/, this.subsService.createSubscriptionRules(payload).toPromise()];
                    case 6:
                        resp = _a.sent();
                        this.alertService.open(subscriptionCreateSuccessAlert(resp, { configRequestKind: 'subscription' }));
                        return [3 /*break*/, 9];
                    case 7:
                        error_1 = _a.sent();
                        this.alertService.open(subscriptionOperationFailureAlert(error_1));
                        return [3 /*break*/, 9];
                    case 8:
                        this.loader.closeLoading();
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    CreateTrialSubsComponent.prototype.applyContext = function () {
        if (!this.context) {
            return;
        }
        this.formGroup.get('city').setValue(this.context.city, { emitEvent: false });
        var modeId = this.context.mode && this.context.mode.id;
        var nextServices = (this.context.modeServices || []).map(function (service) { return Object.assign({}, service, {
            mode: modeId,
            label: service.name + (service.active === false ? ' (inactive)' : '')
        }); });
        var categoryId = this.context.category && this.context.category.id;
        var selectedId = this.context.service && this.context.service.id;
        var key = (this.context.mode && this.context.mode.id) + ':' + categoryId + ':' + selectedId + ':' + nextServices.map(function (service) { return service.id; }).join(',');
        this.services = nextServices;
        if (key !== this.lastServiceKey) {
            this.lastServiceKey = key;
            this.formGroup.get('services').setValue(selectedId ? [selectedId] : [], { emitEvent: false });
        }
        var suspend = this.formGroup.get('suspendServicesPostExpiry');
        suspend.setValue(true, { emitEvent: false });
        suspend.disable({ emitEvent: false });
    };
    return CreateTrialSubsComponent;
}());
export { CreateTrialSubsComponent };
